const ua = navigator.platform;
const isPc = ua.indexOf('Win') === 0;

export default {
  // product: isPc ? 'pc' : 'macdict',
  src: isPc ? 'deskdict.doctrans' : 'macdict.doctrans',
};
